import { render, staticRenderFns } from "./User_History.vue?vue&type=template&id=aa6bdfa6"
import script from "./User_History.vue?vue&type=script&lang=js"
export * from "./User_History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports